/*
 * Main and demo navigation arrays
 */

export default {
    'main': [{
            name: 'Mascotas',
            to: '/',

        },
        {
            name: 'Publicaciones Programadas',
            to: '/borradores',

        },
        {
            name: 'Agregar Usuario',
            to: '/usuarionuevo',

        },
        {
            name: 'Lista de Usuarios',
            to: '/lista',

        },


    ]
}